import { ServiceRequest } from "../types/service.type";
import { useServiceProfile } from "../api/queries/useServiceProfile";
import { useServiceProfileForClient } from "../api/queries/useServiceProfileForClient";
import { ServiceProvider, ServiceRequester } from "../api/types/topServiceProviders.types";

interface UseServiceRequestProfileResult {
  userToShow: ServiceProvider | ServiceRequester | undefined;
  rating: number;
  reviewsCount: number;
  completedJobs: number;
  isLoading: boolean;
  isCurrentUserRequester: boolean;
  isCurrentUserProvider: boolean;
}

export const useServiceRequestProfile = (serviceRequest?: ServiceRequest): UseServiceRequestProfileResult => {
  const { serviceProvider, requester } = serviceRequest || {};

  const isCurrentUserProvider = serviceRequest?.requester !== null;
  const isCurrentUserRequester = serviceRequest?.serviceProvider !== null;

  const userToShow = isCurrentUserProvider ? requester : serviceProvider;
  const providerId = serviceRequest?.serviceProvider?.id;
  const enableProviderProfile = isCurrentUserRequester && Boolean(providerId);

  const requesterId = serviceRequest?.requester?.id;
  const enableRequesterProfile = isCurrentUserProvider && Boolean(requesterId);

  const serviceProfileQuery = useServiceProfile(providerId!, enableProviderProfile);
  const serviceProfileForClientQuery = useServiceProfileForClient(requesterId!, enableRequesterProfile);

  // Use the appropriate query result
  const { data: serviceProfile, isLoading } = isCurrentUserProvider
    ? serviceProfileForClientQuery
    : serviceProfileQuery;

  const rating = serviceProfile?.statuses.find((status) => status.title === "rating")?.value || 0;
  const reviewsCount = serviceProfile?.statuses.find((status) => status.title === "reviewsCount")?.value || 0;
  const completedJobs = serviceProfile?.statuses.find((status) => status.title === "overallJobs")?.value || 0;

  return {
    userToShow,
    rating,
    reviewsCount,
    completedJobs,
    isLoading,
    isCurrentUserRequester,
    isCurrentUserProvider,
  };
};
